<template>
    <div class="shows-calendar">
        <template v-if="loading">
            <div class="spinner spinner-grow"></div>
        </template>
        <template v-else-if="performances && performances.length > 0">
            <slot name="title" />
            <div class="mb-4">
                <ul class="filter">
                    <li class="filter-item">
                        <button class="filter-button btn" :class="{ 'active': !currentYear }" role="button" @click="handleYearClicked(null)">
                            prochainement
                        </button>
                    </li>

                    <template v-for="year in years">
                        <li class="filter-item">
                            <button class="filter-button btn" :class="{ 'active': currentYear === year }" @click="handleYearClicked(year)">
                                {{ year }}
                            </button>
                        </li>
                    </template>
                </ul>

                <hr class="border-primary">
            </div>
            <PerformanceList
                :performances="performances"
                :audiences="audiences"
                :show-months="false"
                :show-company="false"
            />
        </template>
    </div>
</template>

<script>
    import PerformanceList from "./PerformanceList";
    import { getCalendar } from "./api";

    export default {
        components: {
            PerformanceList,
        },
        props: {
            companyId: {
                type: String,
                required: true,
            },
            years: {
                type: Array,
                required: true,
            },
            audiences: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                loading: true,
                performances: null,
                currentYear: null,
            }
        },
        methods: {
            init() {
                this.loading = true;
                getCalendar({
                    companies: [this.companyId],
                    year: this.currentYear,
                })
                .then(data => {
                    this.performances = data.results;
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            handleYearClicked(year) {
                this.currentYear = year;
                this.init();
            },
        },
        created() {
            this.init();
        }
    }
</script>
